module.exports = __webpack_public_path__ + "static/photo2-cb91bf6f4d810c1dd0aa07dcd0f14a49.png";